import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/site/PageHero";
import { ArrowUpRight } from "lucide-react";

export const Route = createFileRoute("/portfolio")({
  head: () => ({
    meta: [
      { title: "Portfolio — Case Studies | BigBrandBooster" },
      { name: "description", content: "Selected work and case studies — measurable growth programs delivered for brands across industries." },
      { property: "og:title", content: "Portfolio — BigBrandBooster" },
      { property: "og:description", content: "Selected work and case studies from BigBrandBooster." },
    ],
    links: [{ rel: "canonical", href: "/portfolio" }],
  }),
  component: PortfolioPage,
});

const work = [
  // { client: "Lumen Skincare", sector: "D2C Beauty", headline: "3.4x ROAS in 90 days", metric: "+218% revenue", color: "from-rose-400 to-pink-600" },
  // { client: "NorthRail", sector: "Travel & Mobility", headline: "Ranked #1 for 142 keywords", metric: "+91% organic", color: "from-sky-400 to-indigo-600" },
  // { client: "FinPilot", sector: "SaaS & Fintech", headline: "Cut CAC by 47%", metric: "12k MQLs/mo", color: "from-emerald-400 to-teal-600" },
  // { client: "Vela Athletics", sector: "Performance Apparel", headline: "Viral creator engine", metric: "62M+ views", color: "from-amber-400 to-orange-600" },
  // { client: "Casa Verde", sector: "Hospitality", headline: "Direct bookings +136%", metric: "−38% paid spend", color: "from-lime-400 to-green-600" },
  { client: "Sweet Dreams", sector: "Real Estate", headline: "Pipeline x 4 in 6 months", metric: "xx", color: "from-violet-400 to-fuchsia-600" },
];

function PortfolioPage() {
  return (
    <>
      <PageHero
        eyebrow="Portfolio"
        title={<>Work that <span className="text-accent">moves numbers.</span></>}
        description="A snapshot of recent engagements — from challenger brands to category leaders."
      />

      <section className="container-page py-24">
        <div className="grid md:grid-cols-2 gap-6">
          {work.map((w) => (
            <article key={w.client} className="group relative overflow-hidden rounded-3xl border border-border bg-card aspect-[4/3]">
              <div className={`absolute inset-0 bg-gradient-to-br ${w.color} opacity-90`} />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,rgba(255,255,255,0.25),transparent_60%)]" />
              <div className="relative h-full flex flex-col justify-between p-8 text-white">
                <div className="flex items-start justify-between">
                  <span className="rounded-full bg-white/15 backdrop-blur px-3 py-1 text-xs font-semibold uppercase tracking-widest">{w.sector}</span>
                  <ArrowUpRight className="h-6 w-6 opacity-80 transition group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
                <div>
                  <p className="text-sm font-medium text-white/80">{w.client}</p>
                  <h3 className="mt-2 font-display text-3xl md:text-4xl font-bold leading-tight">{w.headline}</h3>
                  <p className="mt-4 inline-block rounded-full bg-white/15 backdrop-blur px-4 py-1.5 text-sm font-semibold">{w.metric}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
